import React, { useEffect, useState } from 'react';
import axios from "axios";
import CryptoJS from "crypto-js";
import { motion } from 'framer-motion';
import './Tiles.css';

const API_BASE_URL = "https://api.drivergems.com";

// Function to generate HMAC signature
function generateSignature(method, urlPath, timestamp) {
  const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const Tiles = ({ token , selectedRoId,data,visibleFuels}) => {
 
  const [tileData, setTileData] = useState({
    consumerRegistered: 0,
    rewardsClaimedToday: 0,
    rewardsDistributedToday: 0,
    rewardsClaimedMonth: 0,
    rewardsDistributedMonth: 0,
  });
  
  

  // Fetch tile data
  useEffect(() => {
    //const selectedRoId = localStorage.getItem("selectedRoId");
    if (!selectedRoId) return;

    const fetchTileData = async () => {
      const timestamp = Math.floor(Date.now() / 1000).toString();
      const analyticsUrlPath = `/v1/user/analytics/light/${selectedRoId}`;
      const analyticsSignature = generateSignature("GET", analyticsUrlPath, timestamp);
      const token = localStorage.getItem("authToken");

      try {
        const response = await axios.get(`${API_BASE_URL}${analyticsUrlPath}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Signature": analyticsSignature,
            "X-Timestamp": timestamp,
          },
        });

         // Check UTC vs Local Date
      const nowUTC = new Date().getUTCDay();
      const nowLocal = new Date().getDay();

      const isDifferentDay = nowUTC !== nowLocal;

      setTileData({
        consumerRegistered: Math.abs(response.data.user_referrals || 0),
        rewardsClaimedToday: isDifferentDay ? 0 : Math.abs(response.data.current_day_reward_claimed || 0),
        rewardsDistributedToday: isDifferentDay ? 0 : Math.abs(response.data.current_day_reward_spends || 0),
        rewardsClaimedMonth: Math.abs(response.data.current_month_reward_claimed || 0),
        rewardsDistributedMonth: Math.abs(response.data.current_month_reward_spends || 0),
      });
      } catch (error) {
        console.error("Error fetching tile data:", error);
      }
    };

    fetchTileData();
  }, [selectedRoId, token]);

  

  const tileLabels = [
    "Consumer Registered",
    "Points Redeemed today",
    "Points Awarded today",
    "Points Redeemed this month",
    "Points Awarded this month",
  ];

  const tileValues = [
    tileData.consumerRegistered,
    tileData.rewardsClaimedToday,
    tileData.rewardsDistributedToday,
    tileData.rewardsClaimedMonth,
    tileData.rewardsDistributedMonth,
  ];

  return (
    <div className="tiles-wrapper">
      

      {/* Tiles Section */}
      <div className="tiles-container">
        {tileLabels.map((label, index) => (
          <motion.div
            key={index}
            className="tile"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: index * 0.3 }}
          >
            <div className="rotateStar">
              <div className="star">★</div>
            </div>
            <p className="middle-text">{tileValues[index]}</p>
            <h3>{label}</h3>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Tiles;
